import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ComissionsRoutingModule } from './comissions-routing.module';
import { ListVotesComponent } from './components/list-votes/list-votes.component';


@NgModule({
  declarations: [
    ListVotesComponent,
  ],
  imports: [
    CommonModule,
    ComissionsRoutingModule
  ],
  exports: [
    ListVotesComponent
  ]
})
export class ComissionsModule { }
